import { Educapoint } from "./Educapoint";

/**
 * @returns {React.ReactNode} - return an Animation of Point. 
 */
export function AnimationPoint() {

    return (
        <Educapoint />

    );

}